<template>
  <div class="page-goods-group">
    <div class="title title-left title-label">{{mGroupTitle}}</div>
    <Scroll ref="myScroll" :height="mScrollHeight"
            :loading-text="mReachText"
            :on-reach-top="handleRefresh"
            :on-reach-bottom="handleFeed"
            :distance-to-edge="0">
      <div v-if="!mGoodsList"
           class="no-content-tip">{{$t('common.tip_loading')}}</div>
      <div v-else-if="mGoodsList.length > 0" style="padding: 10px 20px">
        <Row type="flex" :gutter="20">
          <Col v-for="(goods, i) in mGoodsList" :key="i" :xs="12" :sm="8" :md="6" :lg="4">
            <MyGoods
              :value="goods"
              @on-buy="goOrderAdd(goods)"
              @on-detail="goGoodsDetail(goods)"/>
          </Col>
        </Row>
      </div>
      <div v-else class="no-content-tip">{{$t('goods.tip_no_items')}}</div>
    </Scroll>
  </div>
</template>
<script>
    import { httpGetParams, CancelToken } from '@/api/http';
    import MyGoods from '@/components/MyGoodsNew';
    import common from '../mixins/common';

    export default {
        components: {
            MyGoods
        },
        mixins: [common],
        data () {
            return {
                mGroupTitle: '',
                mGroupId: 0,
                mSearchKey: '',

                loading: false,
                mPage: 1,
                mTotal: 0,
                goods_class: '',
                mScrollHeight: 300,

                mReachText: null,
                mGoodsList: null,

                form: {
                    page: 1,
                    pageSize: 18
                }
            }
        },
        methods: {
            onRefresh (route) {
                if (!route) {
                    route = this.$route;
                }
                let id = route.query.id;
                if (typeof id === 'string') {
                    id = parseInt(id);
                }
                this.mGroupId = 0;
                if (typeof id === 'number' && id > 0) {
                    this.mGroupId = id;
                }
                if (route.query.group) {
                    this.mGroupTitle = route.query.group;
                }

                this.mSearchKey = '';
                if (route.query.key) {
                    this.mSearchKey = route.query.key;
                    if (this.mGroupTitle) {
                        this.mGroupTitle += '>>';
                    }
                    this.mGroupTitle += this.$t('page.goods_group.label_search') + this.mSearchKey;
                }
                this.loadData();
            },
            loadData (more, resolve) {
                this.form.page = 0;
                if (more) {
                    this.form.page = this.mPage + 1;
                }
                if (this.mGroupId) {
                    this.form.class_id = this.mGroupId;
                }
                if (this.mSearchKey) {
                    this.form.name = this.mSearchKey;
                }
                this.loading = true;
                if (!resolve) {
                    this.$Spin.show();
                }
                if (this.cancel) {
                    this.cancel();
                    this.cancel = null;
                }
                httpGetParams('/v1/goods', this.form, new CancelToken((c) => {
                    this.cancel = c;
                })).then(res => {
                    if (res.current_page) {
                        this.mPage = res.current_page;
                    } else {
                        this.mPage = this.form.page;
                    }
                    this.mTotal = res.total;
                    if (more && this.mGoodsList) {
                        this.mGoodsList.push(...res.data);
                    } else {
                        this.mGoodsList = res.data;
                    }
                }).catch(() => {
                }).finally(() => {
                    if (!this.mGoodsList) {
                        this.mGoodsList = [];
                    }
                    if (this.cancel) {
                        this.cancel = null;
                    }
                    this.loading = false;
                    if (resolve) {
                        resolve();
                    } else {
                        this.$Spin.hide();
                    }
                });
            },
            handleRefresh () {
                if (this.loading) {
                    return;
                }
                this.mReachText = this.$t('common.tip_refresh');
                return new Promise(resolve => {
                    setTimeout(() => {
                        this.loadData(false, resolve);
                    }, 2000);
                });
            },
            handleFeed () {
                if (this.loading) {
                    return;
                }
                if (this.mTotal < this.form.pageSize) {
                    return this.handleRefresh();
                }
                this.mReachText = this.$t('common.tip_loadmore');
                return new Promise(resolve => {
                    setTimeout(() => {
                        this.loadData(true, resolve);
                    }, 2000);
                });
            },
            goGoodsDetail (goods) {
                this.$router.face.goodsDetail(goods);
            },
            goOrderAdd (goods) {
                this.$router.face.order(goods).go();
            }
        },
        beforeRouteUpdate (to, from, next) {
            this.onRefresh(to);
            next();
        },
        created () {
            if (window.screen.width < 500) {
                this.goods_class += 'goods-min-layout'
            } else if (window.screen.width < 750) {
                this.goods_class += 'goods-med-layout'
            }
            const pageSize = Math.ceil(window.screen.width / 200) *
                Math.ceil(window.screen.height / 200);
            this.form.pageSize = pageSize < 10 ? 10 : pageSize;
            this.onRefresh();
        },
        beforeDestroy () {
            if (this.cancel) {
                this.cancel();
                this.cancel = null;
            }
        }
    }
</script>
